import { useCallback, useMemo } from 'react'
import {
  useDraggable as useDndKitDraggable,
  UseDraggableArguments,
} from '@dnd-kit/core'
import { useIsTemplateAttributeMultiSelected } from '@/pages/DocumentPage/features/templateAttributesMultiSelect/useIsTemplateAttributeMultiSelected'
import { useDocumentState } from '@/state'

export const useMultiSelectDraggable = (args: UseDraggableArguments) => {
  const draggable = useDndKitDraggable(args)
  const isMultiSelected = useIsTemplateAttributeMultiSelected({
    templateAttributeId: args.id as string,
  })
  const delta = useDocumentState((state) => state.multiSelectDelta)

  const onMouseDown = useCallback(
    (e: any) => {
      e.stopPropagation()

      const onDraggableMouseDown = draggable?.listeners?.onMouseDown
      if (onDraggableMouseDown && typeof onDraggableMouseDown === 'function') {
        onDraggableMouseDown(e)
      }
    },
    [draggable?.listeners?.onMouseDown],
  )

  const transform = useMemo(
    () => ({
      ...draggable.transform,
      x: isMultiSelected ? delta.x : draggable.transform?.x,
      y: isMultiSelected ? delta.y : draggable.transform?.y,
    }),
    [draggable.transform, isMultiSelected, delta.x, delta.y],
  )

  return {
    ...draggable,
    transform,
    listeners: {
      ...draggable.listeners,
      onMouseDown,
    },
  }
}
